import { ModuleEnum } from '../models/common/Enums';

export interface TopluFaturaSiparisi {
    moduleKey: string
    orderId: string
}

/**
 * Faturalanacaklar (19.10.2026): seçili satırlardan toplu fatura ucuna (Invoice/AddInvoiceFromOrders) gidecek liste.
 * Seçim sırası korunur (fatura başlığı ilk siparişe göre oluşur). Bu ekrandan faturalanmayan modüllerin satırları eskisi
 * gibi atlanır. Aynı siparişin birden çok satırı seçiliyse hepsi gönderilir: sunucu siparişi bir kez alır, açıklamadaki
 * İRS NO kararı eskisi gibi son satıra bakar.
 */
export const topluFaturaSiparisleri = (kayitlar: { moduleKey: string, orderId: string }[]): TopluFaturaSiparisi[] =>
    kayitlar
        .filter(x => x.moduleKey === ModuleEnum.AMBAR || x.moduleKey === ModuleEnum.YURTICI_KARGO)
        .map(x => ({ moduleKey: x.moduleKey, orderId: x.orderId }));
